import { post } from '@/utils/network/axios-helper';
import type { IPageDataBoxType, IGetAnswerList, ISaveAnswerList, IParamsType, IResult } from '@/utils/ctype';

export const getListeningContent = (params: IParamsType) => {
  return post<{list: IPageDataBoxType[];}>('/api/simulate/get-listening-info', params);
};

export const getAnswerList = (params: IParamsType) => {
  return post<IGetAnswerList>('/api/simulate/get-listening-draft-info', params);
};

export const saveAnswerList = (params: ISaveAnswerList) => {
  return post<{id:number;}>('/api/simulate/save-listening-info', params);
};

export const submitAnswer = (params: IParamsType) => {
  return post<{id:number;}>('/api/simulate/finished-listening', params);
};

export const getResult = (params: IParamsType) => {
  return post<IResult>('/api/simulate/get-listening-record-answer-info', params);
};